import { render, staticRenderFns } from "./SessionViewUserPermissionsCard.vue?vue&type=template&id=10c2b2cd&scoped=true&"
import script from "./SessionViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./SessionViewUserPermissionsCard.vue?vue&type=script&lang=js&"
import style0 from "./SessionViewUserPermissionsCard.vue?vue&type=style&index=0&id=10c2b2cd&lang=scss&scoped=true&"
import style1 from "./SessionViewUserPermissionsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2b2cd",
  null
  
)

export default component.exports